import { Link } from '@tanstack/react-router'
import { QUALITY_TIERS_BEST_FIRST, type QualityTierPeer } from '@/api/quality-tiers'
import { ManufacturerRatingBadge } from '@/components/manufacturer-rating-badge'
import { cn } from '@/lib/utils'

const SHOWN_PER_TIER = 4

/** Other manufacturers' tiers in one category, best first; parent-category tiers are muted. */
export function TierPeers({ peers, className }: { peers: QualityTierPeer[]; className?: string }) {
  if (!peers.length) return null
  return (
    <dl className={cn('flex flex-wrap gap-x-4 gap-y-1 text-sm', className)}>
      {QUALITY_TIERS_BEST_FIRST.map((tier) => {
        const inTier = peers.filter((peer) => peer.quality_tier === tier)
        if (!inTier.length) return null
        const hidden = inTier.length - SHOWN_PER_TIER
        return (
          <div key={tier} className="flex min-w-0 flex-wrap items-baseline gap-x-1.5">
            <dt>
              <ManufacturerRatingBadge rating="quality_tier" value={tier} className="px-1.5 py-0" />
            </dt>
            <dd className="min-w-0">
              {inTier.slice(0, SHOWN_PER_TIER).map((peer, index) => (
                <span key={peer.manufacturer_uuid}>
                  {index > 0 && ', '}
                  <Link
                    to="/manufacturers/$manuId"
                    params={{ manuId: peer.manufacturer_uuid }}
                    title={peer.inherited ? 'Set on a parent category' : undefined}
                    className={cn('hover:underline', peer.inherited && 'text-muted-foreground')}
                  >
                    {peer.name}
                  </Link>
                </span>
              ))}
              {hidden > 0 && <span className="text-muted-foreground"> +{hidden}</span>}
            </dd>
          </div>
        )
      })}
    </dl>
  )
}
